// extracted by mini-css-extract-plugin
module.exports = {"container":"RecipeAddToCart_container__Dt9Id","addToCartButton":"RecipeAddToCart_addToCartButton__nA7Nd"};